var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.68732 31.8751L18.1248 41.3126C21.9998 45.1876 28.2915 45.1876 32.1873 41.3126L41.3332 32.1668C45.2082 28.2918 45.2082 22.0001 41.3332 18.1043L31.8748 8.6876C29.8956 6.70844 27.1665 5.64594 24.3748 5.79177L13.9581 6.29177C9.79148 6.47927 6.47898 9.79177 6.27065 13.9376L5.77065 24.3543C5.64565 27.1668 6.70815 29.8959 8.68732 31.8751Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7913 25.0001C22.6678 25.0001 24.9997 22.6683 24.9997 19.7918C24.9997 16.9153 22.6678 14.5834 19.7913 14.5834C16.9149 14.5834 14.583 16.9153 14.583 19.7918C14.583 22.6683 16.9149 25.0001 19.7913 25.0001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.2e58344ce164203f060746693108827f.svg";
export { ForwardRef as ReactComponent };